import type { BoxProps } from "@chakra-ui/react";
import { Box, Flex } from "@chakra-ui/react";
import type { PropsWithChildren, ReactNode } from "react";
import { useIsDesktop } from "./hooks/use-is-desktop";

export default function ContentColumn(
    p: PropsWithChildren<{
        header?: ReactNode;
        footer?: ReactNode;
        headerProps?: BoxProps;
        footerProps?: BoxProps;
        containerProps?: BoxProps;
        isPrinting?: boolean;
    }>,
) {
    // If you change this, validate print view of dashboard
    const colPadding = 20;
    const isMobile = !useIsDesktop();

    return (
        <>
            {p.header && (
                <HeaderBar orientation="top" {...p.headerProps}>
                    {p.header}
                </HeaderBar>
            )}
            <Flex
                width="100%"
                overflow={p.isPrinting ? "visible" : "auto"}
                className="scroller"
                // [x] Logout button issue here
                zIndex={1}
                flexGrow={2}
            >
                <Box
                    width="100%"
                    minW={
                        isMobile || p.isPrinting
                            ? "100%"
                            : `${780 + colPadding * 2}px`
                    }
                    maxW={
                        isMobile || p.isPrinting
                            ? "100%"
                            : `${1024 + colPadding * 2}px`
                    }
                    margin="auto"
                    marginTop="16px"
                    flexGrow={1}
                    flexShrink={1}
                    padding={`${colPadding}px`}
                    position="relative"
                    overflow="visible"
                    {...p.containerProps}
                >
                    {p.children}
                </Box>
            </Flex>
            {p.footer && (
                <HeaderBar orientation="bottom" {...p.footerProps}>
                    {p.footer}
                </HeaderBar>
            )}
        </>
    );
}

export const HeaderBar = ({
    orientation,
    children,
    ...boxProps
}: PropsWithChildren<{
    orientation: "top" | "bottom";
}> &
    BoxProps) => {
    const shadowDist = orientation === "top" ? 1 : -1;

    return (
        <Box
            width="100%"
            bg="white"
            flexGrow={0}
            flexShrink={0}
            boxShadow={`0 ${shadowDist}px 2px 2px rgba(0,0,0,0.05)`}
            zIndex={2}
            {...boxProps}
        >
            <Box width="100%" maxW="1024px" p={2} margin="auto">
                {children}
            </Box>
        </Box>
    );
};
